import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Mail, User } from 'lucide-react';
import { updateUser } from '../lib/store';
import { Logo } from '../components/Logo';
export function Login() {
  const navigate = useNavigate();
  const handleGuest = () => {
    updateUser({
      isGuest: true,
      loggedIn: false
    });
    navigate('/');
  };
  const handleSimulateLogin = () => {
    updateUser({
      loggedIn: true,
      isGuest: false
    });
    navigate('/');
  };
  return <div className="min-h-screen bg-dark flex justify-center" data-id="element-926">
      <div className="w-full max-w-md bg-dark flex flex-col p-6" data-id="element-927">
        <div className="flex-1 flex flex-col items-center justify-center space-y-8" data-id="element-928">
          <div className="text-center flex flex-col items-center space-y-2 w-full" data-id="element-929">
            <Logo size={180} className="mb-1 max-w-full" data-id="element-930" />
            <p className="text-sm text-light-muted" data-id="element-931">
              Iniciá sesión para continuar
            </p>
          </div>

          <div className="w-full space-y-4" data-id="element-932">
            <Link to="/registro" className="w-full flex items-center justify-center gap-3 bg-dark-card border border-white/10 text-light py-4 rounded-xl font-medium hover:bg-white/5 transition-colors" data-id="element-933">
              <Mail size={20} data-id="element-934" /> Continuar con Email
            </Link>
            <button onClick={handleSimulateLogin} className="w-full flex items-center justify-center gap-3 bg-white text-dark py-4 rounded-xl font-medium hover:bg-gray-100 transition-colors" data-id="element-935">
              Continuar con Google
            </button>
            <button onClick={handleSimulateLogin} className="w-full flex items-center justify-center gap-3 bg-black border border-white/20 text-white py-4 rounded-xl font-medium hover:bg-white/5 transition-colors" data-id="element-936">
              Continuar con Apple
            </button>
          </div>

          <div className="w-full flex items-center gap-4" data-id="element-937">
            <div className="flex-1 h-px bg-white/10" data-id="element-938" />
            <span className="text-xs text-light-muted" data-id="element-939">O</span>
            <div className="flex-1 h-px bg-white/10" data-id="element-940" />
          </div>

          <button onClick={handleGuest} className="w-full flex items-center justify-center gap-3 text-light-muted hover:text-light transition-colors py-2" data-id="element-941">
            <User size={20} data-id="element-942" /> Continuar como invitado
          </button>
        </div>
      </div>
    </div>;
}